<ng-container *ngIf="searchRequest">
  <form class="form mb-3" (submit)="search()">
    <div class="form-group">
      <input type="email" class="form-control" id="topbar-search-term" placeholder="Search" [(ngModel)]="searchRequest.searchTerm" />
    </div>
    <div class="form-group">
      <common-location-typeahead
        [location]="searchRequest.location.location"
        width="100%"
        (locationSelected)="locationSelected($event)"
      ></common-location-typeahead>
    </div>

    <button type="submit" class="btn btn-secondary btn-block btn-mobile-lg" (click)="search()">Search</button>
  </form>
  <div class="pb-2" *ngIf="primaryType == 'all'">
    <h4>Popular Construction Equipment Rentals in {{ cityState }}</h4>
    <app-machine-category-media-list
      [categories]="searchRequest.primaryType.primaryTypes"
      [makes]="searchRequest.make.facets"
      [location]="location"
      [visibleLimit]="6"
      [twoColumns]="true"
    ></app-machine-category-media-list>
  </div>
  <div class="pb-2" *ngIf="primaryType != 'all'">
    <app-topbar-search-results-makes
      [primaryType]="primaryType"
      [location]="location"
      [cityState]="cityState"
      [makes]="searchRequest.make.facets"
    ></app-topbar-search-results-makes>
  </div>
</ng-container>
